import { Controller } from "@hotwired/stimulus"

// When a theme color swatch or native color picker is used, sets the linked hex input.
export default class extends Controller {
  static targets = ["input", "colorPicker"]

  connect() {
    if (this.hasInputTarget && this.hasColorPickerTarget) {
      this.inputTarget.addEventListener("input", () => this.syncColorPicker())
      this.inputTarget.addEventListener("change", () => this.syncColorPicker())
    }
  }

  selectColor(event) {
    const color = event.currentTarget.dataset?.color || event.currentTarget.value
    if (!color || !this.hasInputTarget) return

    const lowered = color.trim().toLowerCase()
    if (lowered === "transparent") {
      this.inputTarget.value = "transparent"
      return
    }

    const hex = color.startsWith("#") ? color : `#${color}`
    this.inputTarget.value = hex
    if (this.hasColorPickerTarget) this.colorPickerTarget.value = hex
  }

  selectColorFromPicker(event) {
    const color = event.currentTarget.value
    if (color && this.hasInputTarget) {
      this.inputTarget.value = color
    }
  }

  syncColorPicker() {
    if (!this.hasColorPickerTarget || !this.hasInputTarget) return
    const hex = this.inputTarget.value.trim()
    if (/^#[0-9a-fA-F]{6}$/.test(hex)) {
      this.colorPickerTarget.value = hex
    }
  }
}
